import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import st from "@/styles/CreditPage.module.scss";
import React, {useEffect, useLayoutEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import CommonClass from "@/utils/common";
import StaticRangeSlider from "@/ui/StaticRangeSlider.tsx";
import {useNavigate, useParams} from "react-router-dom";
import LoanInterface from "@/types_and_interfaces/loan_interface.ts";
import useCommon from "@/hooks/common.ts";
import useLoans from "@/hooks/loans.ts";
import PlusIcon from "@/svg/PlusIcon.tsx";
import clsx from "clsx";
import {CircularProgress} from "@mui/material";
import {isMobile} from "react-device-detect";
// import eventEmitter from "@/utils/event_emmiter_instance.ts";
// import DividerSimple from "@/ui/DividerSimple.tsx";
// import {penalty_amount} from "@/utils/constants.ts";
import DashboardClass from "@/utils/dashboard_class.ts";
import PaymentHistory from "@/components/PaymentHistory.tsx";
import LoginLoader from "@/ui/LoginLoader.tsx";
import Pay from "@/components/Pay.tsx";
import PayToday from "@/ui/PayToday.tsx";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
// import GetContractModal from "@/ui/modals/GetContractModal.tsx";



const CreditPage:React.FC = () => {

    const {urn} = useParams()
    const loans = useLoans()
    const {t} = useTranslation()
    // const [backUrl, setBackUrl] = useState("")
    const [open_graphic, set_open_graphic] = useState<boolean>(false)
    const navigate = useNavigate();
    const credit:LoanInterface | undefined = loans.getLoanByContract(urn as string)
    const is_cr_undefined = typeof credit === "undefined"
    const common_hook = useCommon()
    // const current_cr_type = credit?.product_group
    const not_cr_line = credit?.product_group !== "Credit Line"
    const cr_date = new Date(credit ?  credit?.origin_created_at : "")
    cr_date.setMonth(cr_date.getMonth() + (credit ?  credit?.nr_of_installments : 0));
    
    const header_type_handle  = () => {
        
        if(credit === undefined) return "gray"
        
        if(typeof credit !== "undefined" && typeof credit?.restant_days === "number" && credit.restant_days > 0) {
            return "danger"
        }
        
        if(typeof credit !== "undefined" && credit?.r_status === "settled") {
            return "gray"
        }
        
        switch (credit?.r_status_simplified) {
            case "unknown":
                return "gray"
            case "danger":
                return "danger"
            case "success":
                return "primary"
            case "pending":
                return "secondary"
            default:
                return "primary"
        }
        

    }

    
    useLayoutEffect(() => {
        // backUrlHandler()

        return () => {
            localStorage.removeItem(CommonClass.local_storage_fields.back_url)
        }
    }, []);
    
    useEffect(() => {
        if(typeof credit !== undefined) {
            if(credit?.r_status === "settled") {
                navigate(DashboardClass.dashboard_routes.StandartCredit)
            }
        }
    }, [credit]);
    
    
    return (
        <>

            <DashboardGenComponent

                responsive1

                backUrl={DashboardClass.dashboard_routes.StandartCredit}

                header_type={header_type_handle()}

                heading={
                    <div className={st.heading}>
                        {t("credit_details")} <span> {t("contract_nr1")} <span onClick={() => common_hook.copyToClipboard(urn || "")} className={st.copy}>{urn}</span> </span>
                    </div>
                }

                header_content={
                    <div
                        style={{padding:is_cr_undefined ? "0" : "16px" }}
                        className={clsx(st.header_content, !not_cr_line && st.is_cr_line)}
                    >

                        {is_cr_undefined ? (
                            <LoginLoader className={st.loader} />
                        ) : (
                            <>
                                {/*{not_cr_line && (*/}
                                {/*    <div className={st.top}>*/}
                                {/*        <strong>*/}
                                {/*            {t("credit_nr")} {urn}*/}
                                {/*        </strong>*/}
                                {/*    </div>*/}
                                {/*)}*/}

                                <div className={st.center}>

                                    <div>
                                        <span>
                                            {t("credit_amount")}
                                        </span>
                                        <strong>
                                            {CommonClass.formatMoneyAmount(Number(credit?.capital))} {t("currency")}
                                        </strong>
                                    </div>

                                    <div>
                                        <span>
                                            {t("requested")}
                                        </span>
                                        <strong>
                                            {common_hook.formatMomentDate(credit?.origin_created_at)}
                                        </strong>
                                    </div>

                                    <div>
                                        <span>
                                            {t("credit_end")}
                                        </span>

                                        <strong>
                                            {common_hook.formatMomentDate(cr_date.toString())}
                                        </strong>
                                    </div>

                                </div>

                                {credit?.r_status_simplified === "success" && (
                                    <StaticRangeSlider
                                        max={credit.installments?.length || 0}
                                        value={credit.installments_paid}
                                        danger={credit?.restant_days > 0}
                                        // to_fixed
                                    />
                                )}

                                {not_cr_line && (
                                    <div className={st.bottom}>

                                        <div>
                                            <span>
                                                {t("period")}
                                            </span>

                                            <strong>
                                                {credit?.nr_of_installments} {t("months")}
                                            </strong>
                                        </div>



                                        {not_cr_line && (
                                            <div>

                                                {(Array.isArray(credit?.installments) && credit?.installments.length) ? (
                                                    <>
                                                        <span>
                                                            {t("monthly_payment")}
                                                        </span>
                                                        <strong>
                                                            {CommonClass.formatMoneyAmount(Number(credit?.installments[0].amount))} {t("currency")}
                                                        </strong>
                                                    </>
                                                ) : null}
                                            </div>
                                        )}

                                        {(!credit?.restant_days && credit?.pay_deadline_days > 0) ? (

                                            <div>
                                                <span>
                                                    {t("next_payment")}
                                                </span>

                                                {/*TODO : take care of percentage, needs to change*/}

                                                <strong className={clsx(credit?.pay_deadline_days < 6 && st.danger)}>
                                                    {credit?.pay_deadline_days + " " + t(CommonClass.time_word_handling(credit?.pay_deadline_days))}
                                                </strong>
                                            </div>

                                        ) : null}

                                        {credit?.pay_deadline_days === 0 ? (

                                            <PayToday />

                                        ) : null}

                                    </div>
                                )}
                            </>
                        )}

                    </div>
                }

                column_center={
                    <div className={st.column_center}>

                        <Pay credit={credit}  mobile/>

                        {(!is_cr_undefined && credit?.r_status === "new" && not_cr_line) && (
                            <div className={st.progress}>

                                <div className={st.bar}>
                                    <StaticRangeSlider
                                        max={credit.installments?.length || 0}
                                        value={credit.installments_paid}
                                        danger={credit?.restant_days > 0}
                                        to_fixed
                                    />
                                </div>

                                <div className={st.from_to}>
                                    <div className={st.paid}>
                                        <span>
                                            {t("paid")}
                                        </span>

                                        <strong>
                                            {CommonClass.formatMoneyAmount(Number(credit?.inst_amount)) + " " + t("currency")}
                                        </strong>
                                    </div>

                                    <div className={st.paid}>
                                        <span>
                                            {t("rest")}
                                        </span>

                                        <strong>
                                            {CommonClass.formatMoneyAmount(Number(credit?.capital)) + " " + t("currency")}
                                        </strong>
                                    </div>
                                </div>

                            </div>
                        )}

                        {credit?.r_status !== "settled" ? (
                            <div className={st.reimboursment}>
                                <div
                                    onClick={() => {
                                        if (isMobile) {
                                            set_open_graphic((x) => !x)
                                        }
                                    }}
                                    className={st.header}
                                >
                                    <strong>
                                        {t("reimbursement_schedule")}
                                    </strong>

                                    <button
                                        onClick={() => {
                                            if (!isMobile) {
                                                set_open_graphic((x) => !x)
                                            }
                                        }}
                                        className={clsx(st.button, open_graphic && st.active)}

                                    >
                                        <span>
                                            {!open_graphic ? t("show_schedule") : t("hide_schedule")}
                                        </span>

                                        <PlusIcon/>
                                    </button>
                                </div>

                                <div className={clsx(st.graphic, open_graphic && st.active)}>
                                    {Array.isArray(credit?.installments) ? (

                                        <>
                                            {credit?.installments.length ? (
                                                <table>

                                                    <thead>
                                                        <tr>
                                                            <th>{t("payment_date")}</th>
                                                            <th>{t("to_pay")}</th>
                                                            {/*<th>{t("status")}</th>*/}
                                                        </tr>
                                                    </thead>

                                                    <>

                                                        <tbody>
                                                        {credit?.installments.map((inst, i) => {
                                                            return (
                                                                <tr
                                                                    className={clsx(
                                                                        inst.status === "Overdue" && st.restant,
                                                                        inst.status === "Paid" && st.success,
                                                                        inst.status === "Partial Paid" && st.warn,
                                                                    )}
                                                                    key={`installment_${i}`}
                                                                >
                                                                    <td>
                                                                        {common_hook.formatMomentDate(inst.date)}

                                                                        {inst.status === "Partial Paid" ? (
                                                                            <span className={st.warn_span}>{t("partial_paid")}</span>
                                                                        ) : null}

                                                                        {inst.status === "Overdue" ? (
                                                                            <span className={st.restant_span}>{t("restant1").replace("{{days}}", String(inst?.restant_days)) + t(CommonClass.time_word_handling(inst?.restant_days))}</span>
                                                                        ) : null}

                                                                        {inst.status === "Paid" ? (
                                                                            <span className={st.success_span}>{t("paid")}</span>
                                                                        ) : null}
                                                                    </td>

                                                                    <td>
                                                                        {`${CommonClass.formatMoneyAmount(Number(inst.amount))} ${t("currency")}`}
                                                                    </td>
                                                                    {/*<td>{`${inst.amount} ${t("currency").toUpperCase()}`}</td>*/}
                                                                </tr>
                                                            )
                                                        })}
                                                        </tbody>

                                                    </>

                                                </table>
                                            ) : (
                                                <span className={st.emptyness_span}>
                                                    {t("empty_payment_schedule")}
                                                </span>
                                            )}

                                        </>


                                    ) : <CircularProgress color={"success"}/>}
                                </div>


                            </div>
                        ) : null}

                        {credit?.document_received_at !== null && (
                            <div className={st.contract}>
                                <strong>
                                    {t("contract")}
                                </strong>

                                <button
                                    onClick={() => {
                                        eventEmitter.emit(CommonClass.ModalEvents.OpenGetContractModal, credit)
                                    }}
                                >
                                    {t("download_contract")}
                                </button>

                            </div>
                        )}
                        <PaymentHistory
                            payments={credit?.payments}
                        />

                    </div>
                }

                column_right={
                    <Pay credit={credit} />
                }
            />

            
        </>
    )
}




export default CreditPage